<template>
  <div class="table-con">

    <div class="lx-search-con">
      <Form ref="searchForm" :model="searchData" inline @keydown.native.enter.prevent="getLists">

        <slot name="searchFormItem"></slot>

        <FormItem v-if="showSearchForm">
          <Button type="primary" @click="getLists()" icon="ios-search">搜索</Button>
        </FormItem>
        <FormItem v-if="showSearchForm">
          <Button type="primary" @click="resetSearchForm()">重置</Button>
        </FormItem>

        <slot name="otherBtn"></slot>
      </Form>

    </div>


    <Table border
           :columns="tableTitle"
           :data="dataLists"
           :ref="tabelRef"
           :height="sonTableHeight"
           :highlight-row="true"
           @on-row-click="rowClick"
           @on-selection-change="onSelectChange"
           @on-sort-change="onSortChange"
           row-key="rowKey">
    </Table>
    <div class="page">
      <Page show-sizer show-elevator show-total transfer v-if="showPage"
            :total="totalCount"
            :page-size-opts="pageSizeOpts"
            :page-size="currentPageSize"
            @on-change="changePage"
            :current="currentPage"
            @on-page-size-change="changePageSize"
      />
    </div>
  </div>
</template>

<script>
  export default {
    name: "curtailTable",
    props:{
      tabelRef:{
        type:String,
        default:'curtailTable'
      },
      tableHeight:{
        type:Number,
      },
      tableTitle:{
        type:Array,
        default: ()=>[]
      },
      //是否显示页码
      showPage:{
        type: Boolean,
        default: true
      },
      showSearchForm:{
        type: Boolean,
        default: true
      },
      searchData:{
        type:Object,
        default:()=>{return {}}
      },
      defaultSearchParam:{
        type:Object,
        default:()=>{return {}}
      },
      tableApi:{
        type:String,
        default: ''
      },
      doneFunction:{
        type:Function,
        default:()=>{}
      },
      tableData:{
        type:Array,
        default:()=>[],
      },
      onSelectChange:{
        type:Function,
        default:()=>{}
      },
      onSortChange:{
        type:Function,
        default:()=>{}
      },
      rowKey:{
        type:String,
        default:'id',
      }
    },
    data(){
      return {
        sonTableHeight:this.tableHeight,
        currentPage:1,
        currentPageSize:20,
        dataLists:[],
        totalCount:0,      //数据总条数
        pageSizeOpts:[10,20,50,100],
      }
    },
    methods:{
      changePage(page){
        this.currentPage = page
        this.getLists()
      },
      changePageSize(page_size){
        this.currentPageSize = page_size
        this.getLists()
      },
      setTableHeight() {
        const self = this;
        if (self.tableHeight) {
          self.sonTableHeight = self.tableHeight;
          return;
        }
        const tableRef = self.$refs[self.tabelRef];
        if (tableRef && tableRef.$el) {
          // 视口高度过小时（如手机横屏），计算结果可能过小甚至为负导致表格内容不可见，兜底最小高度
          const autoHeight = window.innerHeight - tableRef.$el.offsetTop - (self.showPage ? 200 : 150);
          self.sonTableHeight = Math.max(autoHeight, 300);
        } else {
          // 默认高度，避免报错
          self.sonTableHeight = 500;
        }
      },
      handleWindowResize() {
        this.setTableHeight();
      },
      resetSearchForm(){
        this.$refs.searchForm.resetFields()
        this.currentPage = 1
        this.getLists()
      },
      async getLists(){
        let apiUrl = this.tableApi;
        let params = {};
        params['page'] = this.currentPage
        params['pagesize'] = this.currentPageSize
        for (let key in this.defaultSearchParam){
          params[key] = this.defaultSearchParam[key]
        }
        for (let key in this.searchData){
          params[key] = this.searchData[key]
        }

        let res = await this.$commonFun.postProxy(apiUrl,params)
        this.dataLists = res.data
        this.totalCount = res.count
        this.doneFunction(res)
      },
      rowClick(currentRow){
        this.$emit('on-row-change',currentRow)
      }
    },
    mounted(){
      this.$nextTick(function () {
        this.setTableHeight()
      })
      // 用 addEventListener 替代 window.onresize 直接赋值：同一页面多个表格会互相覆盖监听，
      // 导致手机横竖屏切换时部分表格高度不更新
      window.addEventListener('resize', this.handleWindowResize)
      if (this.tableApi){
        this.getLists()
      }else{
        this.dataLists = this.tableData
        this.totalCount = this.dataLists.length
      }
    },
    beforeDestroy(){
      window.removeEventListener('resize', this.handleWindowResize)
    },
    watch:{
      sonTableHeight (val) {
        this.sonTableHeight = val
      },
      tableData(val){
        this.dataLists = val
        this.totalCount = this.dataLists.length
      },
      tableHeight(){
        this.setTableHeight()
      }
    }

  }
</script>

<style scoped lang="less">
  .table-con{
    ::-webkit-scrollbar {
      /*滚动条整体样式*/
      width : 15px;  /*高宽分别对应横竖滚动条的尺寸*/
      height: 15px;
    }
    ::-webkit-scrollbar-thumb {
      /*滚动条里面小方块*/
      border-radius   : 10px;
      background-color: skyblue;
      background-image: -webkit-linear-gradient(
              45deg,
              rgba(255, 255, 255, 0.2) 25%,
              transparent 25%,
              transparent 50%,
              rgba(255, 255, 255, 0.2) 50%,
              rgba(255, 255, 255, 0.2) 75%,
              transparent 75%,
              transparent
      );
    }
      ::-webkit-scrollbar-track {
        /*滚动条里面轨道*/
        box-shadow   : inset 0 0 5px rgba(0, 0, 0, 0.2);
        background   : #ededed;
        border-radius: 10px;
      }
    .page{
      position: relative;
      margin-top: 10px;
      left: 20px;
    }
  }
</style>
